import React, { useEffect, useRef, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import {
	Flex,
	Typography,
	Modal,
	notification,
	DatePicker,
	Tag,
	Table,
	Checkbox,
	Row,
	Col,
	Button,
	Select,
} from "antd";
import { CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import AddressJob from "../map/AddressJob";
import { CSVLink } from "react-csv";
import { getAggregateCogsCost } from "../utils/CogCost";
const { Text, Title } = Typography;

const WasteReport = ({ history }) => {
	const [loading, setLoading] = useState(false);
	const [loadingTable, setLoadingTable] = useState(false);
	const [jobs, setJobs] = useState([]);
	const [startDate, setStartDate] = useState(dayjs().startOf("month"));
	const [plant, setPlant] = useState("All");
	const [modalOpenJobAddress, setModalOpenJobAddress] = useState(false);
	const [plantOptions, setPlantOptions] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();
	const shipAddress = useRef(null);
	const latitude = useRef(null);
	const longitude = useRef(null);
	const plantId = useRef(null);

	const refDownload = useRef();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Confirm",
			dataIndex: "confirm",
			key: "confirm",
			width: 150,
			render: (value, record) => {
				return (
					<Flex gap={16}>
						<Checkbox checked={value} />
						{record.creditHold === true && <Text strong>Credit on Hold</Text>}
					</Flex>
				);
			},
		},
		{
			title: "Job ID",
			dataIndex: "jobId",
			key: "jobId",
			width: 100,
			render: (value, record) => {
				return (
					<Text
						strong
						underline
						style={{ cursor: "pointer" }}
						onClick={() => history.push(`/job/${record.id}`)}
					>
						{value}
					</Text>
				);
			},
			sorter: (a, b) => {
				const aVal = isNaN(a.jobId) ? a.jobId : Number(a.jobId);
				const bVal = isNaN(b.jobId) ? b.jobId : Number(b.jobId);
				return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
			},
			sortDirections: ["ascend", "descend"],
		},
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			width: 200,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Seller",
			dataIndex: "seller",
			key: "seller",
			width: 200,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Time",
			dataIndex: "time",
			key: "time",
			width: 150,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Job Address",
			dataIndex: "address",
			key: "address",
			width: 200,
			render: (value, record) => {
				return (
					<Text
						style={{ cursor: "pointer" }}
						underline
						onClick={() => {
							latitude.current = record.latitude;
							longitude.current = record.longitude;
							shipAddress.current = record.shipAddress;
							plantId.current = record.plantId;
							setModalOpenJobAddress(true);
						}}
					>
						{value}
					</Text>
				);
			},
		},
		{
			title: "Load YD3",
			dataIndex: "loadYD3",
			key: "loadYD3",
			width: 120,
			render: (value, record) => {
				return (
					<Flex gap={16} justify="center">
						<Text>{value}</Text>
					</Flex>
				);
			},
		},
		{
			title: "Target YD3",
			dataIndex: "targetYD3",
			key: "targetYD3",
			width: 120,
			render: (value, record) => {
				return <Text>{`${value} + ${record.balance || 0}`}</Text>;
			},
		},
		{
			title: "Mix Design",
			dataIndex: "mixDesign",
			key: "mixDesign",
			width: 200,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Slump",
			dataIndex: "slump",
			key: "slump",
			width: 100,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Fiber YD3",
			dataIndex: "fiber",
			key: "fiber",
			width: 100,
			render: (value, record) => {
				return (
					<Flex gap={16}>
						<Checkbox checked={value} />
						<Text>{record.fiberQuantity}</Text>
					</Flex>
				);
			},
		},
		{
			title: "Cogs",
			dataIndex: "cogs",
			key: "cogs",
			width: 100,
			render: (value) => {
				return <Text>${value}</Text>;
			},
		},
		{
			title: "Sold Price",
			dataIndex: "soldPrice",
			key: "soldPrice",
			width: 100,
			render: (value) => {
				return <Text>${value}</Text>;
			},
		},
		{
			title: "Gross",
			dataIndex: "gross",
			key: "gross",
			width: 100,
			render: (value) => {
				return <Text>${value}</Text>;
			},
		},
		{
			title: "Approved Price",
			dataIndex: "approvedPrice",
			key: "approvedPrice",
			width: 100,
			render: (value) => {
				return (
					<Flex gap={16}>
						<Checkbox checked={value} />
						<Text>EC</Text>
					</Flex>
				);
			},
		},
		{
			title: "Factored Invoice",
			dataIndex: "factoredInvoice",
			key: "factoredInvoice",
			width: 100,
			render: (value) => {
				return (
					<Flex gap={16}>
						<Checkbox checked={value} />
						<Text>Yes/No</Text>
					</Flex>
				);
			},
		},
		{
			title: "Minimum Price",
			dataIndex: "minimumPrice",
			key: "minimumPrice",
			width: 100,
			render: (value) => {
				return <Text>${value}</Text>;
			},
		},
		{
			title: "Maximum Price",
			dataIndex: "maximumPrice",
			key: "maximumPrice",
			width: 100,
			render: (value) => {
				return <Text>${value}</Text>;
			},
		},
		{
			title: "Pour/Type",
			dataIndex: "pourType",
			key: "pourType",
			width: 100,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Job Status",
			dataIndex: "jobStatus",
			key: "jobStatus",
			width: 150,
			onCell: (record) => {
				let bg = "";

				if (record.customerCreditHold === true) {
					bg = "#ffffff";
				} else {
					switch (record.jobStatus) {
						case "Trouble":
							bg = "#7a7977";
							break;
						case "Inactive":
							bg = "#ffffff";
							break;
						case "Poured":
							bg = "#7ad765";
							break;
						case "Ready to Load":
							bg = "#208928";
							break;
						case "Ready to be scheduled":
							bg = "#208928";
							break;
						case "Pouring":
							bg = "#fff569";
							break;
						case "Date moved":
							bg = "#d9a809";
							break;
						case "Operations done (AR)":
							bg = "#fce0a2";
							break;
						case "Company cancellation":
							bg = "#e087fa";
							break;
						case "Customer cancellation":
							bg = "#ad87fa";
							break;
						case "Quote":
							bg = "#c3c2c0";
							break;
						case "A/R Confirmed":
							bg = "#31b9f7";
							break;
						case "Scheduled":
							bg = "#e3495d";
							break;
						default:
							bg = "#fff569";
							break;
					}
				}

				return {
					style: {
						backgroundColor: bg,
					},
				};
			},
			render: (value) => {
				return (
					<Flex vertical gap={16}>
						{value}
					</Flex>
				);
			},
		},
		{
			title: "Scheduled Date",
			dataIndex: "readyToBeScheduledDateFormat",
			key: "readyToBeScheduledDateFormat",
			width: 150,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		localStorage.getItem("jobHold") === "true" && {
			title: "Hold",
			dataIndex: "creditHold",
			key: "creditHold",
			width: 100,
			render: (value, record) => {
				return (
					<Flex vertical gap={16}>
						<Checkbox checked={value} />
						{value && <Text strong>Job Hold</Text>}
					</Flex>
				);
			},
		},
		{
			title: "Check In",
			dataIndex: "measurement",
			key: "measurement",
			width: 100,
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Ice Surcharge",
			dataIndex: "iceSurcharge",
			key: "iceSurcharge",
			width: 100,
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Light Surcharge",
			dataIndex: "lightSurcharge",
			key: "lightSurcharge",
			width: 100,
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Pour",
			dataIndex: "pour",
			key: "pour",
			width: 100,
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Comments",
			dataIndex: "comments",
			key: "comments",
			width: 150,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Waste Reason",
			dataIndex: "commentWaste",
			key: "commentWaste",
			width: 150,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			width: 150,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Franchise",
			dataIndex: "franchise",
			key: "franchise",
			render: (value) => {
				return (
					<Tag
						color={
							value === "57Concrete"
								? "blue"
								: value === "Castle"
									? "green"
									: "cyan"
						}
					>
						{value}
					</Tag>
				);
			},
		},
	].filter(Boolean);

	useEffect(() => {
		getJobs();
	}, [startDate, plant]);

	useEffect(() => {
		getPlants();
	}, []);

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];

				list.push({ value: "All", label: "All" });

				data.payload
					.filter((item) => item.name !== "Laredo")
					.map((item) => {
						list.push({
							value: item._id,
							label: item.name,
						});
					});
				setPlantOptions(list);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const sanitize = (val) =>
		typeof val === "string" ? val.replace(/"/g, "'") : val || "NA";

	const refactorJobStatus = (jobStatus) => {
		let status = jobStatus;
		if (status === "ok") {
			status = "Poured";
		} else if (status === "Confirm") {
			status = "A/R Confirmed";
		} else if (status === "Active") {
			status = "Pouring";
		} else if (status === "Ready to Load") {
			status = "Ready to be scheduled";
		}
		return status;
	};

	const getJobs = async () => {
		try {
			setLoading(true);

			const start = startDate.startOf("month").format("YYYY-MM-DD");
			const end = startDate.endOf("month").format("YYYY-MM-DD");

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const url =
				api +
				`/job/dateplant/waste/57Concrete?startDate=${start}&endDate=${end}&plant=${plant}`;
			const { data } = await axios.get(url);
			if (data.success) {
				const dataList = [];
				data.payload.map((job, index) => {
					let restrict = false;
					let confirm = false;
					const tipoPago = job.customer.paymentType;
					const validado = job.approved;

					if (
						localStorage.getItem("role") === "Finance" ||
						tipoPago !== "PrePay" ||
						validado
					) {
						restrict = false;
					} else {
						restrict = true;
					}

					// regla para habilitar el confirm
					if (validado) {
						confirm = true;
					} else {
						if (
							localStorage.getItem("role") === "Finance" ||
							tipoPago !== "Credit"
						) {
							confirm = true;
						} else {
							confirm = false;
						}
					}

					// Excepcion i el cliente esta en credit hold no dejar editar nada
					if (job.hold) {
						confirm = false;
					}

					const cogs = getAggregateCogsCost(job.aggregate);

					dataList.push({
						key: job._id,
						index: index,
						id: job._id,
						jobId: job.number,
						seller: job.seller.name,
						loadYD3: job.loadYD3,
						customer: `${job.customer.customerNumber} ${job.customer.name}`,
						customerId: job.customer._id,
						mixDesign: sanitize(job.psiId ? job.psiId.psi : job.psi),
						franchise: job.franchise || "57Concrete",
						jobStatus: refactorJobStatus(
							job.customer.creditHold === true ? "Inactive" : job.jobStatus,
						),
						time: dayjs(job.scheduledDate).format("h:mm A").toString(),
						address: `${job.customerShipAddress} - ${job.shipAddress}`,
						customerShipAddress: job.customerShipAddress,
						shipAddress: job.shipAddress,
						plant: job.plant.name,
						latitude: job.latitude,
						longitude: job.longitude,
						plantId: job.plant._id,
						targetYD3: job.targetYD3,
						balance: job.balance,
						destinationTime: job.destinationTime,
						destinationMinutes: job.destinationMinutes,
						slump: job.slump,
						job: job,
						logisticConfirmation: job.logisticConfirmation || false,
						fiber: job.fiberQuantity && job.fiberQuantity > 0,
						fiberQuantity: job.fiberQuantity,
						minPrice:
							(getAggregateCogsCost(job.aggregate)) + 50,
						pourType: `${job.jobPoor} / ${job.jobType}`,
						readyToBeScheduledDateFormat: job.readyToBeScheduledDate
							? dayjs(job.readyToBeScheduledDate).format("MM/DD/YYYY hh:mm a")
							: "-",
						measurement: job.measurement || false,
						iceSurcharge: job.iceSurcharge && job.iceSurcharge !== 0,
						lightSurcharge: job.lightSurcharge && job.lightSurcharge !== 0,
						pour: job.pour || false,
						creditHold: job.hold,
						restrict: restrict,
						confirm: confirm,
						customerCreditHold: job.customer.creditHold,
						approvedPrice: job.approvedPrice || false,
						comments: job.comments,
						cogs: Intl.NumberFormat("en-US").format(cogs),
						soldPrice: Intl.NumberFormat("en-US").format(job.unitPrice),
						gross: Intl.NumberFormat("en-US").format(job.unitPrice - cogs),
						factoredInvoice: job.factoredInvoice,
						minimumPrice: Intl.NumberFormat("en-US").format(
							job.psiId ? (job.psiId.minPrice ? job.psiId.minPrice : 0) : 0,
						),
						maximumPrice: Intl.NumberFormat("en-US").format(
							job.psiId ? (job.psiId.price ? job.psiId.price : 0) : 0,
						),
						commentWaste: job.commentWaste || "",
					});
				});

				setJobs(dataList);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingTable(false);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", "Error while trying to get jobs");
			return null;
		}
	};

	const onDateChange = (date) => {
		if (date) {
			setStartDate(date);
		}
	};

	const onChangePlant = (selectedPlant) => {
		setPlant(selectedPlant);
	};

	const RenderSearch = () => {
		return (
			<Row gutter={16} align={"bottom"}>
				<Col span={24} md={4}>
					<Row>
						<Col span={24}>
							<Text>Date</Text>
						</Col>
						<Col span={24}>
							<DatePicker
								picker="month"
								value={startDate}
								onChange={onDateChange}
								format="YYYY-MM"
								size="large"
								disabled={loading}
								allowClear={false}
								style={{ width: "100%" }}
							/>
						</Col>
					</Row>
				</Col>
				{localStorage.getItem("role") !== "Batch" && (
					<Col span={24} md={4}>
						<Row>
							<Col span={24}>
								<Text>Plant</Text>
							</Col>
							<Col span={24}>
								<Select
									style={{
										width: "100%",
									}}
									size="large"
									placeholder="Please select plant"
									options={plantOptions}
									value={plant}
									allowClear={false}
									onChange={onChangePlant}
									loading={loading}
									disabled={loading}
								/>
							</Col>
						</Row>
					</Col>
				)}
			</Row>
		);
	};

	const RenderJobTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				{jobs.length !== 0 && (
					<Table
						title={() => (
							<Flex vertical gap={16}>
								<Title>Jobs</Title>
							</Flex>
						)}
						columns={columns}
						dataSource={jobs}
						pagination={{
							position: ["bottomRight"],
							pageSizeOptions: [10, 20, 50, 100, 250, 500],
							defaultPageSize: 20,
							showSizeChanger: true,
						}}
						scroll={{ x: 3000 }}
						loading={loading || loadingTable}
					/>
				)}
			</Flex>
		);
	};

	const onCloseModalAddress = () => {
		latitude.current = null;
		longitude.current = null;
		shipAddress.current = null;
		plantId.current = null;
		setModalOpenJobAddress(false);
	};

	const RenderModalJobAddress = () => {
		return (
			<Modal
				title={shipAddress.current}
				open={modalOpenJobAddress}
				onCancel={onCloseModalAddress}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1200}
				centered
			>
				<AddressJob
					lat={latitude.current}
					lng={longitude.current}
					address={shipAddress.current}
					plant={plantId.current}
				/>
			</Modal>
		);
	};

	const headers = () => {
		return columns.map((item) => {
			return {
				key: item.key,
				label: item.title,
			};
		});
	};

	return (
		<Layout title="Job Waste Report" description="Job Report">
			<Flex gap={"middle"} vertical>
				<RenderSearch />
				{loading ? <CustomSpinner /> : <RenderJobTable />}
				{contextHolder}
				<RenderModalJobAddress />
				<CSVLink
					data={jobs}
					headers={headers()}
					filename={"57concrete-waste-report.csv"}
					hidden
					ref={refDownload}
				>
					Download report
				</CSVLink>
				<Button
					size="large"
					type="primary"
					style={{ width: "170px" }}
					onClick={(e) => refDownload.current.link.click()}
					loading={loading}
					disabled={jobs.length === 0}
				>
					Download Report
				</Button>
			</Flex>
		</Layout>
	);
};

export default WasteReport;
